import React from 'react';

import { isEmpty } from 'ramda';

import s from './index.module.css';

const noDataPlaceholder = 'No contacts on file.';

const ContactField = ({ label, value }) => {
  if (!value) {
    return null;
  }

  return <div>{`${label}: ${value || '—'}`}</div>;
};

const Contact = ({ title, name, email, tel }) => {
  const isNoData = !(name || email || tel);
  const isNoContactData = !(email || tel);

  return (
    <div className={s.contact}>
      <div className={s.contactTitle}>{title}</div>
      {isNoData && <div>{noDataPlaceholder}</div>}
      {!isNoData && (
        <div>
          {name && <div>{name}</div>}
          {isNoContactData && <div>{noDataPlaceholder}</div>}
          {!isNoContactData && (
            <>
              <ContactField label="Email" value={email} />
              <ContactField label="Tel" value={tel} />
            </>
          )}
        </div>
      )}
    </div>
  );
};

const Contacts = ({ title, contacts }) => {
  const isNoData = isEmpty(contacts);

  return (
    <div className={s.contacts}>
      <div className={s.contactsTitle}>{title}</div>
      {isNoData && <div>{noDataPlaceholder}</div>}
      {!isNoData &&
        contacts.map((contact) => {
          return (
            <Contact
              key={contact.id}
              title={contact.title}
              name={contact.name}
              email={contact.email}
              tel={contact.phone}
            />
          );
        })}
    </div>
  );
};

export default Contacts;
